// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SigningEvidence } from './signing-evidence';
import {
    SigningEvidenceFromJSON,
    SigningEvidenceFromJSONTyped,
    SigningEvidenceToJSON,
    SigningEvidenceToJSONTyped,
} from './signing-evidence';

/**
 * 
 * @export
 * @interface SigningRecord
 */
export interface SigningRecord {
    /**
     * 
     * @type {string}
     * @memberof SigningRecord
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof SigningRecord
     */
    created_by: string;
    /**
     * 
     * @type {string}
     * @memberof SigningRecord
     */
    dta_id: string;
    /**
     * 
     * @type {Array<SigningEvidence>}
     * @memberof SigningRecord
     */
    evidence: Array<SigningEvidence>;
    /**
     * 
     * @type {string}
     * @memberof SigningRecord
     */
    evidence_hash: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SigningRecord
     */
    required_roles: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SigningRecord
     */
    signing_record_id: string;
    /**
     * 
     * @type {string}
     * @memberof SigningRecord
     */
    stage: string;
    /**
     * 
     * @type {string}
     * @memberof SigningRecord
     */
    updated_at: string;
}

/**
 * Check if a given object implements the SigningRecord interface.
 */
export function instanceOfSigningRecord(value: object): value is SigningRecord {
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('created_by' in value) || value['created_by'] === undefined) return false;
    if (!('dta_id' in value) || value['dta_id'] === undefined) return false;
    if (!('evidence' in value) || value['evidence'] === undefined) return false;
    if (!('evidence_hash' in value) || value['evidence_hash'] === undefined) return false;
    if (!('required_roles' in value) || value['required_roles'] === undefined) return false;
    if (!('signing_record_id' in value) || value['signing_record_id'] === undefined) return false;
    if (!('stage' in value) || value['stage'] === undefined) return false;
    if (!('updated_at' in value) || value['updated_at'] === undefined) return false;
    return true;
}

export function SigningRecordFromJSON(json: any): SigningRecord {
    return SigningRecordFromJSONTyped(json, false);
}

export function SigningRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigningRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'created_at': json['created_at'],
        'created_by': json['created_by'],
        'dta_id': json['dta_id'],
        'evidence': ((json['evidence'] as Array<any>).map(SigningEvidenceFromJSON)),
        'evidence_hash': json['evidence_hash'],
        'required_roles': json['required_roles'],
        'signing_record_id': json['signing_record_id'],
        'stage': json['stage'],
        'updated_at': json['updated_at'],
    };
}

export function SigningRecordToJSON(json: any): SigningRecord {
    return SigningRecordToJSONTyped(json, false);
}

export function SigningRecordToJSONTyped(value?: SigningRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'created_at': value['created_at'],
        'created_by': value['created_by'],
        'dta_id': value['dta_id'],
        'evidence': ((value['evidence'] as Array<any>).map(SigningEvidenceToJSON)),
        'evidence_hash': value['evidence_hash'],
        'required_roles': value['required_roles'],
        'signing_record_id': value['signing_record_id'],
        'stage': value['stage'],
        'updated_at': value['updated_at'],
    };
}
